// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".free-video-view .banner-view{height:15.625rem;width:100%}.free-video-view .banner-view .banner-img{width:100%}", ""]);
// Exports
module.exports = exports;
